export const redirects = {
  desktop:
    import.meta.env.VITE_DESKTOP_DETECTED_REDIRECT || 'https://verified.com.au',
}
